module.exports = __webpack_public_path__ + "img/changZuiHu4.500c6d68.png";